import React from "react";
import { Segment } from "semantic-ui-react";
import {
  toggleBreadcrum,
  setPageTitle,
  
} from "../../store/Page";

import { connect } from "react-redux";
class UtmTracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false, 
    }; 
    this.props.toggleBreadcrum({ toggle: false });
  }
   
  render() {
    return (
      <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
      <div className="kt-content kt-grid__item kt-grid__item--fluid">
          <div className="yr-body-p kt-margin-t-20">
              <div className="row">
                  <div className="col-md-12">
                      <h3>Custom campaigns</h3>
                      <p>Add parameters to URLs to identify the campaigns that refer traffic.</p>
                      <p>By adding campaign parameters to the destination URLs you use in your ad campaigns, you can collect information about the overall efficacy of those campaigns, and also understand where the campaigns are more effective. For example, your Summer Sale campaign might be generating lots of revenue, but if you're running the campaign in several different social apps, you want to know which of them is sending you the customers who generate the most revenue. Or if you're running different versions of the campaign via email, video ads, and in-app ads, you can compare the results to see where your marketing is most effective.</p>
                      <p>When a user clicks a referral link, the parameters you add are sent to Analytics, and the related data is available in the Campaigns reports.</p>
                      <h3>Parameters</h3>
                      <p> There are 5 parameters you can add to your URLs:</p>
                      <ul>
                          <li>utm_source: Identify the advertiser, site, publication, etc. that is sending traffic to your property, for example: google, newsletter4, billboard.</li>
                          <li>utm_medium: The advertising or marketing medium, for example: cpc, banner, email newsletter.</li>
                          <li>utm_campaign: The individual campaign name, slogan, promo code, etc. for a product.</li>
                          <li>utm_term: Identify paid search keywords. If you're manually tagging paid keyword campaigns, you should also use utm_term to specify the keyword.</li>
                          <li>utm_content: Used to differentiate similar content, or links within the same ad. For example, if you have two call-to-action links within the same email message, you can use utm_content and set different values for each so you can tell which version is more effective.</li>
                      </ul>
                      <p>Each parameter must be paired with a value that you assign. Each parameter-value pair then contains campaign-related information.
For example, you might use the following parameter-value pairs for your Summer Sale campaign:</p>
                      <ul class="spaced-list">
                          <li>utm_source = summer-mailer to identify traffic that results from your Summer Sale email campaign</li>
                          <li>utm_medium = email to identify traffic from the email campaign vs. the in-app campaign</li>
                          <li>utm_campaign = summer-sale to identify the overall campaign</li>
                          <li>If you used these parameters, your custom-campaign URL would be:https://www.example.com/?utm_source=summer-mailer&amp;utm_medium=email&amp;utm_campaign=summer-sale</li>
                          <li><strong>Ref. Page 1 URL:</strong> <a href="https://support.google.com/analytics/answer/1033863" target="_blank"><strong>Click here</strong></a></li>
                          <li><strong>Ref. Page 2 URL:</strong> <a href="https://ga-dev-tools.appspot.com/campaign-url-builder/" target="_blank"><strong>Click here</strong></a></li>
                      </ul>
                  </div>
              </div>
          </div>
      </div>
  </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state.user.company,
  };
};

export default connect(mapStateToProps, {
  toggleBreadcrum,
  setPageTitle,
  
})(UtmTracking); 
